var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('keep-alive',[_c('router-view')],1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"logo-wrap"},[_c('article',{staticClass:"logo"},[_c('img',{attrs:{"src":require("@/assets/img/enterprise/banner.png"),"alt":""}})])])
}]

export { render, staticRenderFns }